module.exports = __webpack_public_path__ + "img/emoji_75.d960a294.png";